import getProcessEnv from '@src/env/processEnv';

export type FrontendEnv =
    | 'local'
    | 'development'
    | 'sandbox'
    | 'cypress'
    | '7shifts_demo'
    | '7shifts_prod';

const NODE_ENVS = {
    DEVELOPMENT: 'development',
    LOCAL: 'local',
    PRODUCTION: 'production',
    TEST: 'test',
    // used for jest and cypress
    DEMO: 'demo'
} as const;

const { VERSION, PROFILE } = getProcessEnv();

export const getIsProd = (): boolean => {
    const FRONTEND_ENV = getFrontendEnv();
    return FRONTEND_ENV === '7shifts_prod';
};
//We can't use process.env.NODE_ENV to determine if we are in demo. View more in frontend/src/env/processEnv.ts.
export const getIsDemo = (): boolean => {
    const FRONTEND_ENV = getFrontendEnv();
    return FRONTEND_ENV === '7shifts_demo';
};
export const getIsSandbox = (): boolean => {
    return getFrontendEnv() === 'sandbox';
};
export const getIsDevelopment = (): boolean => {
    const { NODE_ENV } = getProcessEnv();
    return NODE_ENV === NODE_ENVS.LOCAL || NODE_ENV === NODE_ENVS.DEVELOPMENT;
};

export const getIsTest = (): boolean => {
    const { NODE_ENV } = getProcessEnv();
    return NODE_ENV === NODE_ENVS.TEST;
};

export const getVersion = (): string => VERSION;
export const getProfile = (): string => PROFILE;

export function getFrontendEnv(): FrontendEnv | '' {
    return window.__bootstrap ? window.__bootstrap.env : '';
}

export const getWindowOrigin = (): string => {
    return window.location.origin;
};

// gets environment variable that is consistent with the backend
export const getDatadogEnv = () => {
    switch (true) {
        case getIsProd():
            return 'prod';
        case getIsDemo():
            return 'demo';
        case getIsDevelopment():
            return 'local';
        default:
            return 'unknown';
    }
};

export const getStaticUrl = (): string => {
    const { VERSION } = getProcessEnv();
    let basePath = '';

    // When running locally against a remote backend (dev:demo / dev:sandbox),
    // skip the CDN — locale files and other statics are served from local
    // app/webroot by Vite.
    const isLocalRemoteDev =
        (getIsDemo() || getIsSandbox()) &&
        window.location.hostname === 'localhost';

    if (getIsProd()) {
        basePath = `https://static.7shifts.com/${VERSION}`;
    }
    if (getIsDemo() && !isLocalRemoteDev) {
        basePath = `https://static.7shiftsdemo.com/${VERSION}`;
    }

    return `${basePath}/js/`;
};
